import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
} from '@mui/material'
import React from 'react'
import { CustomTextArea } from 'src/consumer/components/helperComponents'

export default function TherapyReportConfirmation({
  submitForm,
  isSaving,
  closeModal,
  reportReason,
  setReportReason,
}) {
  return (
    <>
      <DialogTitle sx={{ pb: 1.5, pt: 2.5, px: 3 }}>
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontWeight: 600,
            fontSize: '18px',
            color: '#1a1a1a',
          }}
        >
          No Follow-up Date
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ px: 3, py: 2 }}>
        <Typography
          variant="body2"
          sx={{
            color: '#495057',
            fontSize: '14px',
            mb: 2,
          }}
        >
          Please share why a follow-up isn&apos;t needed.
        </Typography>

        <CustomTextArea
          value={reportReason}
          onChange={(e) => setReportReason(e.target.value)}
          placeholder="e.g., Treatment completed, patient will schedule later..."
          minRows={3}
          style={{
            fontSize: '14px',
            fontFamily: 'inherit',
            lineHeight: 1.5,
            borderRadius: '12px',
          }}
        />
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 2.5,
          pt: 1.5,
          gap: 1.5,
        }}
      >
        <Button
          onClick={() => closeModal()}
          disabled={isSaving}
          sx={{
            textTransform: 'none',
            px: 2.5,
            py: 0.875,
            fontSize: '14px',
            fontWeight: 500,
            color: '#6c757d',
            borderRadius: '10px',
            transition: 'all 0.2s ease',
            '&:hover': {
              backgroundColor: '#f8f9fa',
              transform: 'translateY(-1px)',
            },
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={!reportReason?.trim() || isSaving}
          onClick={() => {
            submitForm()
          }}
          sx={{
            textTransform: 'none',
            px: 3,
            py: 0.875,
            fontSize: '14px',
            fontWeight: 600,
            minWidth: 100,
            borderRadius: '10px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
            transition: 'all 0.2s ease',
            '&:hover': {
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.18)',
              transform: 'translateY(-1px)',
            },
            '&:active': {
              transform: 'translateY(0)',
            },
            '&:disabled': {
              backgroundColor: '#e9ecef',
              color: '#adb5bd',
              boxShadow: 'none',
            },
          }}
        >
          {isSaving ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CircularProgress size={16} sx={{ color: '#fff' }} />
              <span>Saving...</span>
            </Box>
          ) : (
            'Continue'
          )}
        </Button>
      </DialogActions>
    </>
  )
}
